<template>
  <el-cascader
    :size="size"
    :disabled="disabled"
    v-model="val"
    :options="list"
    :props="{ expandTrigger: 'hover' }"
    filterable
    separator="的"
    popper-class="event-analysis-target-column"
    @change="handleChange"
  ></el-cascader>
</template>

<script>
export default {
  name: 'event-analysis-target-column',
  props: {
    size: {
      type: String,
      default: 'small',
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Object],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      idx: 0,
      val: [],
      list: [],
    };
  },
  watch: {
    value() {
      this.initValue();
    },
    options() {
      this.initList();
    },
  },
  created() {
    this.initList();
    this.initValue();
  },
  methods: {
    initValue() {
      if (typeof this.value === 'string') {
        this.val = [this.value];
      } else {
        const { type, calcType } = this.value;
        const recoverVal = [type];
        if (calcType) {
          recoverVal.push(calcType);
        }
        this.val = recoverVal;
      }
    },
    initList() {
      const list = [];
      this.options.forEach(item => {
        const nItem = {
          label: item.desc,
          value: item.type,
        };
        if (item.calcList && item.calcList.length) {
          nItem.children = item.calcList.map(subItem => ({ label: subItem.calcDesc, value: subItem.calcType }));
        }
        list.push(nItem);
      });
      this.list = list;
    },
    handleChange() {
      const [type, calcType] = this.val;
      const retVal = { type };
      if (calcType) {
        retVal.calcType = calcType;
      }
      this.$emit('input', retVal);
      this.$emit('onChange', retVal, this.getSelectedValueWithLabel(this.val));
    },

    getSelectedValueWithLabel(val) {
      const [type, calcType] = val || [];
      const { options } = this;
      const { desc, calcList = [] } = options.find(op => op.type === type) || {};
      const value = {
        type: { value: type, label: desc },
        calc: { value: '', label: '' },
      };
      if (calcType && calcList && calcList.length) {
        const { calcDesc } = calcList.find(op => op.calcType === calcType) || {};
        value.calc.label = calcDesc;
        value.calc.value = calcType;
      }

      return value;
    },
  },
};
</script>

<style lang="less">
.event-analysis-target-column {
  .el-cascader-panel {
    .el-cascader-menu {
      margin-bottom: 10px;
    }
  }
}
</style>
